var KnockoutHelpers = function($,_,ko,helpers,moment){
    

    var safeApplyBindings = function(viewModal, viewName, onSuccess) {

        if (viewModal == null) {
            console.log("no view model");
            return;
        }

        if (viewName == null || viewName == "") {
            console.log("no view name supplied");
            return;
        }

        var viewElements = $('#' + viewName);
        console.log(viewElements);

        if (viewElements == null || viewElements.length == 0) {
            console.error("no elements matching " + viewName);
            return;
        }
        if (viewElements.length > 1) {

            console.log("multiple elements matching " + viewName);
            return;
        }

        typeof onSuccess === 'function' && onSuccess(); // http://stackoverflow.com/questions/6792663/javascript-style-optional-callbacks

        ko.applyBindings(viewModal, viewElements[0]);

    }

    ko.bindingHandlers.hidden = {
        update: function(element, valueAccessor) {
            ko.bindingHandlers.visible.update(element, function() {
            return !ko.utils.unwrapObservable(valueAccessor());
            });
        }
    };

    ko.bindingHandlers.highlightValidationError = {    

        update: function (element, valueAccessor) {

            var value = valueAccessor();

            if (value && value.isValid) {

              //  $(element).closest('.question').css('background-color', !value.isModified() || value.isValid() ? '#f1f1f1' : '#e2e280'); 
                
                var parent = $(element).closest('.question'), className = 'question-invalid';
                
                !value.isModified() || value.isValid() ? parent.removeClass(className) : parent.addClass(className);

            }

        }
    };

    ko.bindingHandlers.modal = {
        init: function(element, optionsAccessor, allBindingsAccessor, viewModel, bindingContext) {
            
            var $element = $(element);

            $element.appendTo('body');

            if ($element.attr('tabindex') === undefined) {
                $element.attr('tabindex', -1);
            }

            $element.modal(ko.toJS(optionsAccessor()));

            $element.on('hidden.bs.modal', function() {
                var options = ko.utils.unwrapObservable(optionsAccessor());
                options.show(false);
            });

            $(document).on('keyup', function(e) { e.which === 27 && $element.modal('hide') });

            // hide elements inside modal unless we are showing it
            var _showAccessor = showAccessor.bind(optionsAccessor, optionsAccessor);
            ko.bindingHandlers['if'].init(element, _showAccessor, allBindingsAccessor, viewModel, bindingContext);
        },
        update: function(element, optionsAccessor) {
            var _showAccessor = showAccessor.bind(optionsAccessor, optionsAccessor);

            $(element).modal(_showAccessor() ? 'show' : 'hide');
        }
    };

    ko.bindingHandlers.datePicker = {
        init: function(element, valueAccessor) {

            var data      = valueAccessor()
            , isDateRange = data.isDateRange && ko.unwrap(data.isDateRange)
            , template    = isDateRange ? require('DateRangeTemplate.html') : require('DateSingleTemplate.html')
            , $template   = $(template);
            $(element).append($template);

            ko.applyBindingsToNode($template[0], { with: data });

            var createDatePicker = function () {  
                $template.datepicker({
                    format         : "dd/mm/yyyy",
                    todayHighlight : true,
                    clearBtn       : true,
                    startDate      : data.startDate,
                    endDate        : data.endDate
                });
            }, destroyDatePicker = function () { $template.datepicker('destroy'); return true }

            data && data.resetObservable && data.resetObservable.subscribe(function (reset) {
                
                reset && destroyDatePicker() && createDatePicker();
            });

            createDatePicker();

            return { controlsDescendantBindings: true };
        }        
    };

    ko.bindingHandlers.formattedDate = {

        update: function(element, valueAccessor, allBindings) {
            
            $(element).text(helpers.formattedDate(moment)(allBindings.get('value') , allBindings.get('format') ))
        }

    };

    
    ko.bindingHandlers.count = {

        update: function(element, valueAccessor, allBindings, filter) {

            var values = ko.unwrap(valueAccessor()), count = _.size(values);

            $(element).text(count ? count : '');
        }
    };
    function showAccessor(accessor) {
        var options = ko.utils.unwrapObservable(accessor());
        return ko.utils.unwrapObservable(options.show);
    }

    ko.extenders.filter = function (target, filterOptions) {

        var subscription
          , filterType = _.isObject(filterOptions) ? filterOptions.type : filterOptions
          , sanitise   = function (newValue) {

            var valueToWrite;

            switch (filterType) {
                case 'non-zero_positive_integer':
                    valueToWrite = parseInt(("" + newValue).replace(/[^0123456789]+/, ''), 10) || '';
                    break;
                case 'phone':
                    valueToWrite = ("" + newValue).replace(/[^0-9\-\(\)\s\+]+/g, '');
                    break;
                case 'person_name':
                    valueToWrite = ("" + newValue).replace(/[0-9\\\/\|\<\>\"\.\!\$\@\%\#\^\&\;\*\(\)\+\,\[\]\{\}\`\¬\~\?\=\£]+/g, '');
                    break;
                case 'postalcode':
                    valueToWrite = ("" + newValue).toUpperCase();
                    break;
                case 'vat_registration_number':
                    valueToWrite = ("" + newValue).replace(/[^0-9A-Z\-\(\)\s\+]+/g, '');
                    break;
                case 'restrictDecimalPlaces':
                    var num = _.toNumber(newValue);
                    valueToWrite = _.isInteger(num) ? num : num.toFixed(filterOptions.params);
                    break;                
                default:
                    valueToWrite = 'filter error';
            }

            if (valueToWrite !== newValue) {

                subscription.dispose();
                target(valueToWrite);
                subscription = target.subscribe(sanitise);
            }

        }

        subscription = target.subscribe(sanitise);
        return target;
    }

    const clearInputOnSelect = true;

    ko.bindingHandlers.typeaheadLocal = {
        update: function (element, valueAccessor, allBindings, filter) {
            // http://stackoverflow.com/a/19366003/1247130 get value to update properly when typeahead choice is selected.

            var templateName
            ,   displayedProperty
            ,   user_typeahead_options = {}
            ,   localData = ko.unwrap(valueAccessor())
            ,   values = allBindings.get("values")
            ,   updater = allBindings['onUpdate']
            ,   cascadeSetName = ko.unwrap(allBindings['cascadeSetName'])
            ,   suggestions = new Bloodhound({

                datumTokenizer : Bloodhound.tokenizers.whitespace,
                queryTokenizer : Bloodhound.tokenizers.whitespace,
                local          : localData

            });

            suggestions.initialize();

            $(element).typeahead("destroy");

            var typeaheadOpts = {
                source: suggestions.ttAdapter(),
                displayKey: displayedProperty || function (item) {
                    return item;
                }
            };

            if (templateName) {
                typeaheadOpts.templates = {
                    suggestion: function (item) {
                        var temp = document.createElement("div");
                        var model = mapping ? mapping(item) : item;
                        ko.renderTemplate(templateName, model, null, temp, "replaceChildren");

                        return temp;
                    }
                };
            }

            $(element)

                .typeahead($.extend({
                    hint: false,
                    highlight: true
                }, user_typeahead_options), typeaheadOpts)

                .keyup(function (e) {

                    if (e.keyCode === 0x20){ 
                    
                        var target = $(e.currentTarget), withBreakingSpace = target.val();

                        target.typeahead('val', helpers.toNbsp(withBreakingSpace));
                    } 
                    
                })
                
            .on("typeahead:selected typeahead:autocompleted", function (e, suggestion) {
                
                console.log('Suggestion', JSON.stringify(values()), suggestion, $(element));
                
                if(!_.includes(values(),suggestion)){

                    values.push(suggestion);
                    _.isFunction(updater) && updater(cascadeSetName);

                    console.log('selected', filter , e , e.target, $(e.target) );

                    $(e.target).typeahead('val', '');
                }

            });
        }
    };

        
    ko.bindingHandlers.typeahead = {
	    update: function (element, valueAccessor, allBindings) {
            // http://stackoverflow.com/a/19366003/1247130 get value to update properly when typeahead choice is selected.

            var templateName           = ko.unwrap(allBindings().templateName)
            ,   mapping                = ko.unwrap(allBindings().mappingFunction)
            ,   onSelect               = allBindings.get("onSelectFunction")
            ,   displayedProperty      = ko.unwrap(allBindings().displayKey)
            ,   user_typeahead_options = ko.unwrap(allBindings().typeaheadOpts) || {}
            ,   value                  = allBindings.get("value")
            ,   url                    = ko.unwrap(valueAccessor())
            ,   remoteFilter           = ko.unwrap(allBindings.get("remoteFilter"))

            var auth = (allBindings.has("authToken")) ? {
                "Authorization": "Bearer " + ko.unwrap(allBindings().authToken)
            } : {};

            var remoteData = {
                url: url,
                ajax: {
                    headers: auth
                }
            };

            if (remoteFilter) {
                remoteData.filter = remoteFilter;
            }

            var resultsLimit = allBindings.get("limit") || 10;

            var suggestions = new Bloodhound({
                datumTokenizer: function (token) {
                    return Bloodhound.tokenizers.whitespace(token);
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: remoteData,
                limit: resultsLimit
            });

            suggestions.initialize();

            $(element).typeahead("destroy");

            var typeaheadOpts = {
                source: suggestions.ttAdapter(),
                displayKey: displayedProperty || function (item) {
                    return item;
                }
            };

            if (templateName) {
                typeaheadOpts.templates = {
                    suggestion: function (item) {
                        var temp = document.createElement("div");
                        var model = mapping ? mapping(item) : item;
                        ko.renderTemplate(templateName, model, null, temp, "replaceChildren");

                        return temp;
                    }
                };
            }

            $(element)
                .typeahead($.extend({
                    hint: false,
                    highlight: true
                }, user_typeahead_options), typeaheadOpts)
            .on("typeahead:selected typeahead:autocompleted", function (e, suggestion) {
                if (onSelect) {
                    onSelect(value, suggestion, e);
                } else if (value && ko.isObservable(value)) {
                    value(suggestion);
                }
            });
        }
    };    
    
    ko.validation.rules['time'] = {
        validator: helpers.isValidTime,
        message  : 'Use mm:hh'
    };

    ko.validation.rules['decimals'] = {
        validator: function (val, otherVal) { return _.isInteger(val) || _.size(_.split(val.toString(), '.')[1]) <= otherVal },
        message: 'No more than {0} decimal places'
    };

    ko.validation.rules['validateGuid'] = {
        validator : helpers.isValidGuid,
        message   : 'Not properly formatted'
    }
    ko.validation.registerExtenders();    
    
    
    return { safeApplyBindings: safeApplyBindings }
}

module.exports = KnockoutHelpers;